import React, { useState } from 'react';
import {
  Box,
  Container,
  Tabs,
  Tab,
  Paper
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  Autorenew as ReplenishmentIcon,
  AttachMoney as ProfitabilityIcon,
  Speed as RotationIcon,
  Warning as AlertIcon
} from '@mui/icons-material';
import InventoryDashboard from './InventoryDashboard';
import ReplenishmentAnalysis from './ReplenishmentAnalysis';
import ProfitabilityAnalysis from './ProfitabilityAnalysis';
import RotationAnalysis from './RotationAnalysis';
import CashRegisterDashboard from './CashRegisterDashboard';
import CashRegisterHistory from './CashRegisterHistory';
import { PointOfSale as CashIcon, History as HistoryIcon } from '@mui/icons-material';

const DashboardView = ({ storeId }) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const tabs = [
    {
      label: 'Dashboard General',
      icon: <DashboardIcon />,
      component: <InventoryDashboard storeId={storeId} />
    },
    {
      label: 'Reposición',
      icon: <ReplenishmentIcon />,
      component: <ReplenishmentAnalysis storeId={storeId} />
    },
    {
      label: 'Rentabilidad',
      icon: <ProfitabilityIcon />,
      component: <ProfitabilityAnalysis storeId={storeId} />
    },
    {
      label: 'Rotación',
      icon: <RotationIcon />,
      component: <RotationAnalysis storeId={storeId} />
    },
    {
      label: 'Caja',
      icon: <CashIcon />,
      component: <CashRegisterDashboard storeId={storeId} />
    },
    {
      label: 'Historial Caja',
      icon: <HistoryIcon />,
      component: <CashRegisterHistory storeId={storeId} />
    }
  ];

  return (
    <Box sx={{ width: '100%', bgcolor: 'background.default', minHeight: '100vh' }}>
      <Container maxWidth="xl" sx={{ py: 3 }}>
        <Paper 
          elevation={0} 
          sx={{ 
            mb: 3, 
            borderRadius: 3,
            overflow: 'hidden',
            border: '1px solid',
            borderColor: 'divider'
          }}
        >
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              bgcolor: 'background.paper',
              '& .MuiTab-root': {
                py: 2,
                px: 3,
                fontSize: '0.95rem',
                fontWeight: 600,
                textTransform: 'none',
                minHeight: 64,
              },
              '& .Mui-selected': {
                color: 'primary.main',
              },
            }}
          >
            {tabs.map((tab, index) => (
              <Tab
                key={index}
                icon={tab.icon}
                iconPosition="start"
                label={tab.label}
                sx={{
                  '&.Mui-selected': {
                    bgcolor: 'primary.main',
                    color: 'white !important',
                    '& .MuiSvgIcon-root': {
                      color: 'white',
                    },
                  },
                }}
              />
            ))}
          </Tabs>
        </Paper>

        <Box>
          {tabs[activeTab].component}
        </Box>
      </Container>
    </Box>
  );
};

export default DashboardView;
